/* eslint-disable react/prop-types */
/* eslint-env browser */
import React from 'react'

import { useTranslator } from '../TranslatorProvider'

interface BusinessesFullListProps {
  host: string
  hostPath: string
  locale: string
  description?: string
  businesses: {
    id: string
    name: string
    seoName: string
  }[]
}

export const BusinessesFullList: React.FC<BusinessesFullListProps> = ({ businesses, description, locale }) => {
  const t = useTranslator(locale)
  return (
    <div>
      <div className="columns is-multiline has-padding-horizontal-medium">
        {description && (
          <div className="column is-12">
            <p>{description}</p>
            {/*
            <p>
              <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
            </p>
            */}
          </div>
        )}
        <div className="column is-12">
          <ul>
            {businesses.map(business => {
              return (
                <div key={business.id} className="media">
                  <div className="media-content is-self-centered">
                    <a
                      href={`/businesses/${business.id}/${business.seoName}`}
                      className="has-text-weight-bold has-text-break-word"
                    >
                      {business.name}
                    </a>
                  </div>
                </div>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
